import {types} from 'mobx-state-tree';

const Notification = types.model('Notification', {
    id: types.optional(types.number, () => Date.now() + Math.random()),
    content: types.frozen({}),
});
export default Notification;
